module.exports = __webpack_public_path__ + "static/media/Venus-berline-promo-banner.9dc3f7ac.jpg";